/**
 * Sims
 * http://simsrecycling.com
 *
 * Copyright (c) 2017 10up
 * Licensed under the GPL-2.0+ license.
 */
( function( window, document, $ ) {

	var AutoSuggest = function() {
		this.settings = null;
		this.el = null;
	};

	AutoSuggest.prototype = {

		init: function( el, settings ) {
			this.settings = settings;
			this.el = el;
			this.initAutoSuggest();
		},

		/**
         * Get autosuggestions via an AJAX request.
         *
         * @returns {void}
         */
		initAutoSuggest: function() {

			if ( this.el ) {
				var baseUrl = this.getSetting( 'getAutoSuggestionsURL' ),
					nonce = this.getSetting( 'nonce' );

				$( this.el ).suggest( baseUrl + '/?_wpnonce=' + nonce );
			}
		},

		getSetting: function( setting ) {
			if ( this.settings && this.settings.hasOwnProperty( setting ) ) {
				return this.settings[setting];
			} else {
				return null;
			}
		}
	};

	var sugggester = new AutoSuggest(),
		equipmentStateSearch = document.getElementById( 'equipment-state-search' ),
		equipmentKeywordSearch = document.getElementById( 'equipment-keyword-search' );

	if ( equipmentStateSearch && locationFinderAPISettings ) {
		sugggester.init( equipmentStateSearch, locationFinderAPISettings );
	}

	if ( equipmentKeywordSearch && EquipmentFinderAPISettings ) {
		sugggester.init( equipmentKeywordSearch, EquipmentFinderAPISettings );
	}

} )( window, document, jQuery );
